import { css } from "@linaria/core";
import React from "react";
import t from "../../../../../i18n";
import classNames from "classnames";
import type { Reparability } from "../../../../../api/Reparability";
import { color, fonts } from "@ui";
import type { Translation } from "../../../../../api/useTranslations";
import ReparabilityTag from "../../../Settings/Setup/Diagnosis/Failures/Reparability";
import { Action } from "..";

const faultUpdate = css`
  font: ${fonts.body2};
  color: ${color.carbon700};
  padding-bottom: 8px;
`;
const faultReparabilityCss = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const reparabilityActionsCss = css`
  display: flex;
  flex-direction: column;
  font: ${fonts.body2};
  gap: 8px;
  color: ${color.carbon900};
`;
export const FaultReparabilityChartTooltip = ({
  showBadge,
  reparabilityActions,
  reparability,
  translations,
}: {
  showBadge: boolean;
  reparabilityActions: {
    text: string;
    action: Reparability;
    intent: string;
    show: boolean;
  }[];
  reparability: Reparability | null;
  translations: Translation;
}) => (
  <div className={faultReparabilityCss}>
    {showBadge && reparability !== null ? (
      <ReparabilityTag reparability={reparability} translations={translations} />
    ) : null}
    {reparabilityActions.length ? (
      <div>
        <p className={faultUpdate}>
          {t("diagnosis.chart.tooltip.subtitle_link.update_reparability")}
        </p>
        <div className={reparabilityActionsCss}>
          {reparabilityActions
            .filter(a => a.show)
            .map(a => (
              <Action
                key={a.action}
                className={classNames({ [a.intent]: true })} //, fullWidth: a.fullWidth
                data-action={a.action}
              >
                {a.text}
              </Action>
            ))}
        </div>
      </div>
    ) : null}
  </div>
);
